import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  CanDeactivate
} from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmDialogComponent } from '../pages/mi-agenda/reserva-hora/confirm-dialog/confirm-dialog.component';
import { ReservaHoraCcComponent } from '../pages/mi-agenda-cc/reserva-hora-cc/reserva-hora-cc.component';
import { ReservaHoraComponent } from '../pages/mi-agenda/reserva-hora/reserva-hora.component';
import { ReservaDoctorComponent } from '../pages/mi-agenda/reserva-doctor/reserva-doctor.component';
import { ReservaOnDemandComponent } from '../pages/mi-agenda/reserva-on-demand/reserva-on-demand.component';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<
  ReservaHoraComponent |
  ReservaHoraCcComponent |
  ReservaDoctorComponent |
  ReservaOnDemandComponent
> {
  constructor(private dialogReserva: MatDialog) {}

  canDeactivate(
    component:any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // BYPASS: si el componente lo indica, no bloquear
    if (component?.skipDeactivateGuard === true) {
      return true;
    }

    // BYPASS: si veníamos redirigiendo a pago, tampoco bloquear
    if (sessionStorage.getItem('od_redirecting') === '1') {
      return true;
    }

    if (
      nextState.url === '/mis-proximas-consultas' ||
      nextState.url.includes('/fila-ondemand')
    ) {
      return true;
    }

    // No preguntar si ya se mostró el resumen o si está en step inicial
    if (component?.showSuccessMessage || component?.steps?.searchDoctor) {
      return true;
    }

    const dialogRef = this.dialogReserva.open(ConfirmDialogComponent);
    return dialogRef.afterClosed();
  }
}